var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",style:({background: _vm.params.colors.background})},[_c('div',{staticClass:"badge__wrapper",style:({color: _vm.params.colors.text})},[_vm._v(" "+_vm._s(_vm.params.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }